import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="py-4">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs md:text-sm text-foreground-500">
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center gap-1.5">
            {item.path ? (
              <Link to={item.path} className="hover:text-primary-600 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
            {index < items.length - 1 && (
              <i className="ri-arrow-right-s-line text-foreground-300"></i>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}